import React from 'react'

const Footer = (props) => {
    return (
        <footer>
          <p className="pFooter"> By tess-tech {props.date} </p>
        </footer>
      );
}
 
export default Footer;
